import { Typography } from "antd";
import styled from "styled-components";

const { Paragraph } = Typography;

export const EnviromentAlertWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 1rem 1rem 0 1rem;
  position: sticky;
  top: 0;
  z-index: 5;
  gap: 1rem;
  background: ${({theme}) => `
    linear-gradient(${theme?.colors?.theme?.warning}33, ${theme?.colors?.theme?.warning}33),
    linear-gradient(${theme?.colors?.common?.white}, ${theme?.colors?.common?.white})
  `};
`
export const EnviromentAlertTitle = styled.h2`
  font-size: 1rem;
  color: ${({theme}) => theme?.colors?.theme?.warning}
`

export const EnviromentAlertText = styled(Paragraph)`
  color: ${({theme}) => theme?.colors?.common?.black};
  margin-bottom: 0;
`